import { RWaveLoader } from '@rgrd/component-library'

import styles from './PageWaveLoader.module.css'

/**
 * Full-page placeholder shown while a page's data loads: the library wave loader
 * centered in the page body. Shared by every top-level page that fetches on
 * load (the Patients table, the patient detail page).
 */
export const PageWaveLoader = () => (
  <div className={styles.loader} aria-hidden="true">
    <RWaveLoader />
  </div>
)
